import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[showIconIfScrollbar]'
})
export class NGSelectDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    const dropdownPanel = document.querySelector<HTMLElement>('ng-dropdown-panel');
    const dropdownPanelItems = document.querySelector<HTMLElement>('.ng-dropdown-panel-items');
    const childDiv = dropdownPanel.querySelector<HTMLElement>('.ng-dropdown-panel-items > div:last-child');
    if (childDiv && childDiv.offsetHeight > dropdownPanel.offsetHeight) {
      this.addArrowIcon(dropdownPanel);
    }
    this.renderer.listen(dropdownPanelItems, 'scroll', (scrollEvent) => {
      this.updateIconDirection(dropdownPanel,dropdownPanelItems);
    });
  }

  private addArrowIcon(parent) {
    const iconElement = this.renderer.createElement('i');
    this.renderer.addClass(iconElement, 'fa');
    this.renderer.addClass(iconElement, 'fa-chevron-down');
    this.renderer.setStyle(iconElement, 'position', 'absolute');
    this.renderer.setStyle(iconElement, 'bottom', '5px');
    this.renderer.setStyle(iconElement, 'left', '50%');
    this.renderer.setStyle(iconElement, 'transform', 'translateX(-50%)');
    this.renderer.appendChild(parent, iconElement);
  }

  private updateIconDirection(parent: HTMLElement, scrollableParent: HTMLElement) {
    const iconElement = parent.querySelector('i.fa');

    if(iconElement){
      if (scrollableParent.scrollTop === scrollableParent.scrollHeight - scrollableParent.clientHeight) {
        this.renderer.removeClass(iconElement, 'fa-chevron-down');
        this.renderer.addClass(iconElement, 'fa-chevron-up');
      } else {
        this.renderer.removeClass(iconElement, 'fa-chevron-up');
        this.renderer.addClass(iconElement, 'fa-chevron-down');
      }
    }
  }
}
